module.exports = __webpack_public_path__ + "1827d93cc17b51c05ab63a035e586bb2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-17.png
// module id = 1563
// module chunks = 0